import { Box, Button, FormGroup, TextField, Typography } from "@mui/material";
import FormTitle from "../../components/helpers/FormTitle";
import { useContext, useState } from "react";
import BusinessIcon from "@mui/icons-material/Business";
import CompaniesList from "../../components/administation/companies/CompaniesList";
import { BasicListContext } from "../../contexts/BasicListContext";
import AppRights from "../../services/AppRights";
import { _ROLES_BACK } from "../../utils/constants";
import BasicRadioGroup from "../../components/form/BasicRadioGoup";
import { _ACTIVE_RADIO_GROUP } from "../../utils/constants";

export const CompanyAdmin = () => {
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const { extraQueryParams, setExtraQueryParams } =
    useContext(BasicListContext);

  return (
    <>
      <AppRights
        roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CONTROLE_GESTION]}
      />
      <FormTitle title="Manage companies" />
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}>
        <Box
          width={"100%"}
          display={"flex"}
          gap={1}
          alignItems={"baseline"}
          sx={{
            borderBottom: "1px solid #ccc",
          }}>
          <BusinessIcon />
          <Typography variant="h6" component="div">
            Companies List
          </Typography>
        </Box>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}>
            <TextField
              id="outlined-basic"
              label="Find"
              variant="outlined"
              size="small"
              name="customFind"
              onBlur={(e) => {
                setExtraQueryParams({
                  ...extraQueryParams,
                  customFind: e.target.value ? e.target.value : null,
                });
              }}
            />
            <FormGroup
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                marginLeft: 2,
              }}>
              <BasicRadioGroup
                setExtraQueryParams={setExtraQueryParams}
                extraQueryParams={extraQueryParams}
                choices={_ACTIVE_RADIO_GROUP}
                defaultValue={extraQueryParams?.active}
                onChange={(e) => {
                  setExtraQueryParams({
                    ...extraQueryParams,
                    active: e.target.value,
                  });
                }}
              />
            </FormGroup>
          </Box>
          <Button
            variant="contained"
            size="small"
            title={"New Company"}
            startIcon={<BusinessIcon />}
            color="success"
            onClick={() => {
              // Modal create user
              setEditData(null);
              setShowModal(true);
            }}>
            {"New Company"}
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          width: "100%",
        }}>
        <CompaniesList
          editData={editData}
          setEditData={setEditData}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      </Box>
    </>
  );
};

export default CompanyAdmin;
